import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import CategoryDropdown from './CategoryDropdown';
import FactoryDropdownMultiple from './FactoryDropdownMultiple';
import RoleDropdown from './RoleDropdown';

const EditPermissionModal = ({ handleClose, show, onAdd, modalInfo }) => {
    const [userID, setUserID] = useState('');
    const [userName, setUserName] = useState('');
    const [selectfactory, setSelectFactory] = useState([]);
    const [selectCategory, setSelectCategory] = useState([]);
    const [selectRole, setSelectRole] = useState([]);
    const [createdBy, setCreatedBy] = useState('');
    const [theShow, setshow] = useState(show);

    useEffect(() => {
        setshow(show);
        setSelectRole([]);
        setUserID(modalInfo.id);
        setUserName(modalInfo.name);
        setSelectFactory(modalInfo.factory);
        setSelectCategory(modalInfo.categoryID);
        setSelectRole(modalInfo.roleID);
        setCreatedBy(localStorage.getItem('badgeID'));
    }, [modalInfo, show])

    const getFactory = (factoryProp) => {
        setSelectFactory(factoryProp);
    };

    const getCategory = (CategoryProp) => {
        setSelectCategory(CategoryProp);
    };

    const getRole = (RoleProp) => {
        setSelectRole(RoleProp);
        setSelectFactory([]);
        setSelectCategory([]);
    };

    const onSubmit = (e) => {
        e.preventDefault();

        if(selectRole == ""){
            alert('Please select a role');
        }
        else if(selectRole == 1){
            if (selectCategory == "") {
                alert('Please select a category');
            }
            else{
                if(!window.confirm('Do you want to submit this?')) {
                    return false;
                }
                const factorylist = selectfactory.toString();
                const categorylist = selectCategory.toString();
    
                onAdd({
                    userID,
                    userName,
                    factorylist,
                    categorylist,
                    selectRole,
                    createdBy
                });
            } 
        }
        else if (selectRole == 2){
            if(selectfactory == ""){
                alert('Please select a factory');
            }
            else{
                if(!window.confirm('Do you want to submit this?')) {
                    return false;
                }
                const factorylist = selectfactory.toString();
                const categorylist = selectCategory.toString();
    
                onAdd({
                    userID,
                    userName,
                    factorylist,
                    categorylist,
                    selectRole,
                    createdBy
                });
            }
        } else {
            if(!window.confirm('Do you want to submit this?')) {
                return false;
            }
            const factorylist = selectfactory.toString();
            const categorylist = selectCategory.toString();

            onAdd({
                userID,
                userName,
                factorylist,
                categorylist,
                selectRole,
                createdBy
            });
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title style={{ marginBottom: '0px' }}>
                    Edit User Permission
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form 
                onSubmit={onSubmit}
                >   
                    <Form.Group className='mb-3'>
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            readOnly
                            type='text'
                            placeholder='Insert the user name here...'
                            style={{ width: '100%' }}
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Badge ID</Form.Label>
                        <Form.Control
                            readOnly
                            type='text'
                            placeholder='Insert the user badge ID here...'
                            style={{ width: '100%' }}
                            value={userID}
                            onChange={(e) => setUserID(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Role</Form.Label>
                        <RoleDropdown
                        getRole={getRole}
                        modalInfo={modalInfo}
                        />
                    </Form.Group>
                    {selectRole == 2 && <Form.Group className='mb-3'>
                        <Form.Label>Factory</Form.Label>
                        <FactoryDropdownMultiple
                        getFactory={getFactory}
                        modalInfo={modalInfo}
                        />
                    </Form.Group>}
                    {selectRole == 1 && <Form.Group className='mb-3'>
                        <Form.Label>Category</Form.Label>
                        <CategoryDropdown
                        getCategory={getCategory}
                        modalInfo={modalInfo}
                        />
                    </Form.Group>}
                    {selectRole == 4 && <Form.Group className='mb-3'>
                        <Form.Label>Category</Form.Label>
                        <CategoryDropdown
                        getCategory={getCategory}
                        modalInfo={modalInfo}
                        />
                    </Form.Group>}
                    {selectRole == 5 && <Form.Group className='mb-3'>
                        <Form.Label>Category</Form.Label>
                        <CategoryDropdown
                        getCategory={getCategory}
                        modalInfo={modalInfo}
                        />
                    </Form.Group>}
                    <Button as='input' type='submit' value='Edit' />
                    <Button variant='outline-secondary' onClick={handleClose}>
                        Close
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditPermissionModal;
